import { render } from "./FacilitatorTools.vue?vue&type=template&id=0f4113b0&scoped=true&ts=true"
import script from "./FacilitatorTools.vue?vue&type=script&lang=ts"
export * from "./FacilitatorTools.vue?vue&type=script&lang=ts"

import "./FacilitatorTools.vue?vue&type=style&index=0&id=0f4113b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4113b0"]])

export default __exports__